import {
  ellipsis,
  inputRules as rules,
  smartQuotes,
} from 'prosemirror-inputrules';
import { Schema } from 'prosemirror-model';

import { emojiRules } from './emoji.rule';
import { horizontalLineRule } from './horizontal-line.rule';
import {
  blockQuoteRule,
  bulletListRule,
  headingRule,
  orderedListRule,
} from './inputrules';
import { markdownInCodeRule } from './markdown-code.rule';
import { markdownEmRule } from './markdown-em.rule';
import { markdownLinkRule } from './markdown-link.rule';
import { markdownStrongRule } from './markdown-strong.rule';
import { typeLinkRule } from './type-link.rule';

export function inputRules(schema: Schema) {
  return rules({
    rules: [
      ...smartQuotes,
      ellipsis,
      ...emojiRules(),
      markdownStrongRule(schema.marks.strong),
      markdownEmRule(schema.marks.em),
      markdownInCodeRule(schema.marks.code),
      markdownLinkRule(schema.marks.link),
      typeLinkRule(schema.marks.link),
      blockQuoteRule(schema.nodes.blockquote),
      orderedListRule(schema.nodes.ordered_list),
      bulletListRule(schema.nodes.bullet_list),
      headingRule(schema.nodes.heading, 6),
      horizontalLineRule(schema.nodes.horizontal_rule),
    ],
  });
}
